import React, { Component } from 'react';
import { Link } from 'react-router-dom';
// import parse from 'html-react-parser';
// import { api_endpoint } from '../../global-config'
// import * as loadingData from "./loandtdd.json";
// import Lottie from "react-lottie";
import { withTranslation } from 'react-i18next';


import Slider from "react-slick";

// const defaultOptions = {
// 	loop: true,
// 	autoplay: true,
// 	animationData: loadingData.default,
// 	rendererSettings: {
// 		preserveAspectRatio: "xMidYMid slice"
// 	}
// };
class BlogTravel extends Component {
	constructor(props) {
		super(props)
		this.state = {

		}
	}

	render() {

		// let publicUrl = process.env.PUBLIC_URL + '/'
		const settings = {
			dots: true,
			infinite: true,
			speed: 2000,
			slidesToShow: 1,
			slidesToScroll: 1,
			// autoplay: true,
			// autoplaySpeed: 10000,
			dotsClass: "button_dot",
			arrows: false
		};
		return (
			<div className="blog-area pd-top-120 viaje-go-top">
				<div className="container">
					<div className="row">
						<div className="col-xl-12 col-lg-12">
							<div className="section-title">
								<h2 className="title wow animated fadeInUp large-text-48 cl-black" data-wow-duration="0.6s" data-wow-delay="0.1s">{this.props.t('Thai Tourist Routes by Locals')}</h2>
								<div className="row">
									<div className="col-lg-9">
										<p className="wow animated fadeInUp large-text light-gray" data-wow-duration="0.6s" data-wow-delay="0.2s">{this.props.t('A special experience of Thai way of travel that will make you fall in love with Thailand even more')}</p>
									</div>
									<div className="col-lg-3" style={{ textAlign: 'end' }}>
										<Link hrefLang={this.props.i18n.language} className="btn btn-gray " to="/routes" style={{ fontSize: 24, marginTop: 0, borderRadius: 39 }}>{this.props.t('View more')}</Link>
									</div></div>

							</div>
						</div>
					</div>
					{/* slider 1 */}
					<Slider {...settings}>
						<div className="row fix-dotslide margin-0">
							<div className="col-lg-6">
								<div className="single-blog single-blog-wrap style-two">
									<div className="thumb single-blog-left-wrap">
										<img className="province-img-travel" src={this.props.route.length < 1 ? null : this.props.route[0].IntroImage} alt="blog" />
									</div>
									<div className="single-blog-details single-blog-right-wrap">
										<h4 className="title large-text">{this.props.route.length < 1 ? null : this.props.route[0].Name.th}</h4>
										{/* <p className="content">{this.props.route.length < 1 ? null : this.props.route[0].IntroText.th}</p> */}
										<Link hrefLang={this.props.i18n.language} className="btn btn-yellow" to={{ pathname: "/" + this.props.i18n.language + "/route/" + this.props.route[0].ID, params: this.props.route[0] !== undefined ? this.props.route[0].ID : null }}><span>{this.props.t('Read more')}<i className="la la-arrow-right" /></span></Link>
									</div>
								</div>
							</div>
							<div className="col-lg-6" >
								<div className="row">
									<div className="col-sm-6">
										<div className="single-blog style-three">
											<div className="thumb">
												<img className="province-img-travel-blog-1" src={this.props.route.length < 1 ? null : this.props.route[1].IntroImage} alt="blog" />
											</div>
											<div className="single-blog-details-wrap">
												<div className="single-blog-details text-center">
													<h4 className="title large-text">{this.props.route.length < 1 ? null : this.props.route[1].Name.th}</h4>
													<Link hrefLang={this.props.i18n.language} className="btn btn-yellow" to={{ pathname: "/" + this.props.i18n.language + "/route/" + this.props.route[1].ID, params: this.props.route[1] !== undefined ? this.props.route[1].ID : null }}><span>{this.props.t('Read more')}<i className="la la-arrow-right" /></span></Link>
												</div>
											</div>
										</div>
									</div>
									<div className="col-sm-6">
										<div className="single-blog style-three">
											<div className="thumb">
												<img className="province-img-travel-blog-1" src={this.props.route.length < 1 ? null : this.props.route[2].IntroImage} alt="blog" />
											</div>
											<div className="single-blog-details-wrap">
												<div className="single-blog-details text-center">
													<h4 className="title large-text">{this.props.route.length < 1 ? null : this.props.route[2].Name.th}</h4>
													<Link hrefLang={this.props.i18n.language} className="btn btn-yellow" to={{ pathname: "/" + this.props.i18n.language + "/route/" + this.props.route[2].ID, params: this.props.route[2] !== undefined ? this.props.route[2].ID : null }}><span>{this.props.t('Read more')}<i className="la la-arrow-right" /></span></Link>
												</div>
											</div>
										</div>
									</div>
									<div className="col-sm-6">
										<div className="single-blog style-three">
											<div className="thumb">
												<img className="province-img-travel-blog-1" src={this.props.route.length < 1 ? null : this.props.route[3].IntroImage} alt="blog" />
											</div>
											<div className="single-blog-details-wrap">
												<div className="single-blog-details text-center">
													<h4 className="title large-text">{this.props.route.length < 1 ? null : this.props.route[3].Name.th}</h4>
													<Link hrefLang={this.props.i18n.language} className="btn btn-yellow" to={{ pathname: "/" + this.props.i18n.language + "/route/" + this.props.route[3].ID, params: this.props.route[3] !== undefined ? this.props.route[3].ID : null }}><span>{this.props.t('Read more')}<i className="la la-arrow-right" /></span></Link>
												</div>
											</div>
										</div>
									</div>
									<div className="col-sm-6">
										<div className="single-blog style-three">
											<div className="thumb">
												<img className="province-img-travel-blog-1" src={this.props.route.length < 1 ? null : this.props.route[4].IntroImage} alt="blog" />
											</div>
											<div className="single-blog-details-wrap">
												<div className="single-blog-details text-center">
													<h4 className="title large-text">{this.props.route.length < 1 ? null : this.props.route[4].Name.th}</h4>
													<Link hrefLang={this.props.i18n.language} className="btn btn-yellow" to={{ pathname: "/" + this.props.i18n.language + "/route/" + this.props.route[4].ID, params: this.props.route[4] !== undefined ? this.props.route[4].ID : null }}><span>{this.props.t('Read more')}<i className="la la-arrow-right" /></span></Link>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						{/* slider 2 */}
						<div className="row fix-dotslide margin-0">
							<div className="col-lg-6">
								<div className="single-blog single-blog-wrap style-two">
									<div className="thumb single-blog-left-wrap">
										<img className="province-img-travel" src={this.props.route.length < 1 ? null : this.props.route[5].IntroImage} alt="blog" />
									</div>
									<div className="single-blog-details single-blog-right-wrap">
										<h4 className="title large-text">{this.props.route.length < 1 ? null : this.props.route[5].Name.th}</h4>
										{/* <p className="content">{this.props.route.length < 1 ? null : this.props.route[5].IntroText.th}</p> */}
										<Link hrefLang={this.props.i18n.language} className="btn btn-yellow" to={{ pathname: "/" + this.props.i18n.language + "/route/" + this.props.route[5].ID, params: this.props.route[5] !== undefined ? this.props.route[5].ID : null }}><span>{this.props.t('Read more')}<i className="la la-arrow-right" /></span></Link>
									</div>
								</div>
							</div>
							<div className="col-lg-6">
								<div className="row">
									<div className="col-sm-6">
										<div className="single-blog style-three">
											<div className="thumb">
												<img className="province-img-travel-blog-1" src={this.props.route.length < 1 ? null : this.props.route[6].IntroImage} alt="blog" />
											</div>
											<div className="single-blog-details-wrap">
												<div className="single-blog-details text-center">
													<h4 className="title large-text">{this.props.route.length < 1 ? null : this.props.route[6].Name.th}</h4>
													<Link hrefLang={this.props.i18n.language} className="btn btn-yellow" to={{ pathname: "/" + this.props.i18n.language + "/route/" + this.props.route[6].ID, params: this.props.route[6] !== undefined ? this.props.route[6].ID : null }}><span>{this.props.t('Read more')}<i className="la la-arrow-right" /></span></Link>
												</div>
											</div>
										</div>
									</div>
									<div className="col-sm-6">
										<div className="single-blog style-three">
											<div className="thumb">
												<img className="province-img-travel-blog-1" src={this.props.route.length < 1 ? null : this.props.route[7].IntroImage} alt="blog" />
											</div>
											<div className="single-blog-details-wrap">
												<div className="single-blog-details text-center">
													<h4 className="title large-text">{this.props.route.length < 1 ? null : this.props.route[7].Name.th}</h4>
													<Link hrefLang={this.props.i18n.language} className="btn btn-yellow" to={{ pathname: "/" + this.props.i18n.language + "/route/" + this.props.route[7].ID, params: this.props.route[7] !== undefined ? this.props.route[7].ID : null }}><span>{this.props.t('Read more')}<i className="la la-arrow-right" /></span></Link>
												</div>
											</div>
										</div>
									</div>
									<div className="col-sm-6">
										<div className="single-blog style-three">
											<div className="thumb">
												<img className="province-img-travel-blog-1" src={this.props.route.length < 1 ? null : this.props.route[8].IntroImage} alt="blog" />
											</div>
											<div className="single-blog-details-wrap">
												<div className="single-blog-details text-center">
													<h4 className="title large-text">{this.props.route.length < 1 ? null : this.props.route[8].Name.th}</h4>
													<Link hrefLang={this.props.i18n.language} className="btn btn-yellow" to={{ pathname: "/" + this.props.i18n.language + "/route/" + this.props.route[8].ID, params: this.props.route[8] !== undefined ? this.props.route[8].ID : null }}><span>{this.props.t('Read more')}<i className="la la-arrow-right" /></span></Link>
												</div>
											</div>
										</div>
									</div>
									<div className="col-sm-6">
										<div className="single-blog style-three">
											<div className="thumb">
												<img className="province-img-travel-blog-1" src={this.props.route.length < 1 ? null : this.props.route[9].IntroImage} alt="blog" />
											</div>
											<div className="single-blog-details-wrap">
												<div className="single-blog-details text-center">
													<h4 className="title large-text">{this.props.route.length < 1 ? null : this.props.route[9].Name.th}</h4>
													<Link hrefLang={this.props.i18n.language} className="btn btn-yellow" to={{ pathname: "/" + this.props.i18n.language + "/route/" + this.props.route[9].ID, params: this.props.route[9] !== undefined ? this.props.route[9].ID : null }}><span>{this.props.t('Read more')}<i className="la la-arrow-right" /></span></Link>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						{/* slider 3 */}
						<div className="row fix-dotslide margin-0">
							<div className="col-lg-6">
								<div className="single-blog single-blog-wrap style-two">
									<div className="thumb single-blog-left-wrap">
										<img className="province-img-travel" src={this.props.route.length < 1 ? null : this.props.route[10].IntroImage} alt="blog" />
									</div>
									<div className="single-blog-details single-blog-right-wrap">
										<h4 className="title large-text">{this.props.route.length < 1 ? null : this.props.route[10].Name.th}</h4>
										{/* <p className="content">{this.props.route.length < 1 ? null : this.props.route[10].IntroText.th}</p> */}
										<Link hrefLang={this.props.i18n.language} className="btn btn-yellow" to={{ pathname: "/" + this.props.i18n.language + "/route/" + this.props.route[10].ID, params: this.props.route[10] !== undefined ? this.props.route[10].ID : null }}><span>{this.props.t('Read more')}<i className="la la-arrow-right" /></span></Link>
									</div>
								</div>
							</div>
							<div className="col-lg-6">
								<div className="row">
									<div className="col-sm-6">
										<div className="single-blog style-three">
											<div className="thumb">
												<img className="province-img-travel-blog-1" src={this.props.route.length < 1 ? null : this.props.route[11].IntroImage} alt="blog" />
											</div>
											<div className="single-blog-details-wrap">
												<div className="single-blog-details text-center">
													<h4 className="title large-text">{this.props.route.length < 1 ? null : this.props.route[11].Name.th}</h4>
													<Link hrefLang={this.props.i18n.language} className="btn btn-yellow" to={{ pathname: "/" + this.props.i18n.language + "/route/" + this.props.route[11].ID, params: this.props.route[11] !== undefined ? this.props.route[11].ID : null }}><span>{this.props.t('Read more')}<i className="la la-arrow-right" /></span></Link>
												</div>
											</div>
										</div>
									</div>
									<div className="col-sm-6">
										<div className="single-blog style-three">
											<div className="thumb">
												<img className="province-img-travel-blog-1" src={this.props.route.length < 1 ? null : this.props.route[12].IntroImage} alt="blog" />
											</div>
											<div className="single-blog-details-wrap">
												<div className="single-blog-details text-center">
													<h4 className="title large-text">{this.props.route.length < 1 ? null : this.props.route[12].Name.th}</h4>
													<Link hrefLang={this.props.i18n.language} className="btn btn-yellow" to={{ pathname: "/" + this.props.i18n.language + "/route/" + this.props.route[12].ID, params: this.props.route[12] !== undefined ? this.props.route[12].ID : null }}><span>{this.props.t('Read more')}<i className="la la-arrow-right" /></span></Link>
												</div>
											</div>
										</div>
									</div>
									<div className="col-sm-6">
										<div className="single-blog style-three">
											<div className="thumb">
												<img className="province-img-travel-blog-1" src={this.props.route.length < 1 ? null : this.props.route[13].IntroImage} alt="blog" />
											</div>
											<div className="single-blog-details-wrap">
												<div className="single-blog-details text-center">
													<h4 className="title large-text">{this.props.route.length < 1 ? null : this.props.route[13].Name.th}</h4>
													<Link hrefLang={this.props.i18n.language} className="btn btn-yellow" to={{ pathname: "/" + this.props.i18n.language + "/route/" + this.props.route[13].ID, params: this.props.route[13] !== undefined ? this.props.route[13].ID : null }}><span>{this.props.t('Read more')}<i className="la la-arrow-right" /></span></Link>
												</div>
											</div>
										</div>
									</div>
									<div className="col-sm-6">
										<div className="single-blog style-three">
											<div className="thumb">
												<img className="province-img-travel-blog-1" src={this.props.route.length < 1 ? null : this.props.route[14].IntroImage} alt="blog" />
											</div>
											<div className="single-blog-details-wrap">
												<div className="single-blog-details text-center">
													<h4 className="title large-text">{this.props.route.length < 1 ? null : this.props.route[14].Name.th}</h4>
													<Link hrefLang={this.props.i18n.language} className="btn btn-yellow" to={{ pathname: "/" + this.props.i18n.language + "/route/" + this.props.route[14].ID, params: this.props.route[14] !== undefined ? this.props.route[14].ID : null }}><span>{this.props.t('Read more')}<i className="la la-arrow-right" /></span></Link>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						{/* <div className="row fix-dotslide">
				<div className="col-lg-6">
					<div className="single-blog single-blog-wrap style-two">
						<div className="thumb single-blog-left-wrap">
							<img src={publicUrl + "assets/img/blog/10.png"} alt="blog" />
						</div>
						<div className="single-blog-details single-blog-right-wrap">
							<Link className="tag" to="/blog-details">Europe</Link>
							<p className="date">19 September 2019</p>
							<h4 className="title">Why You Shouldn’t Ride Elephants In France.</h4>
							<p className="content">Kava contains 30 demos as for now, and we’re planning to release more! Except demos, Kava theme has more and more features for.. users, business, companies, developers, bloggers and other categories of users. Even if you are an absolute beginner</p>
							<Link className="btn btn-yellow" to="/blog-details"><span>{this.props.t('Read more')}<i className="la la-arrow-right" /></span></Link>
						</div>
					</div>
				</div>
				<div className="col-lg-6">
					<div className="row">
						<div className="col-sm-6">
							<div className="single-blog style-three">
								<div className="thumb">
									<img src={publicUrl + "assets/img/blog/11.png"} alt="blog" />
								</div>
								<div className="single-blog-details-wrap">
									<div className="single-blog-details text-center">
										<Link className="tag" to="/blog-details">Europe</Link>
										<p className="date">19 September 2019</p>
										<h4 className="title">Why You Shouldn’t Ride Elephants In Thailand</h4>
										<Link className="btn btn-yellow" to="/blog-details"><span>{this.props.t('Read more')}<i className="la la-arrow-right" /></span></Link>
									</div>
								</div>
							</div>
						</div>
						<div className="col-sm-6">
							<div className="single-blog style-three">
								<div className="thumb">
									<img src={publicUrl + "assets/img/blog/12.png"} alt="blog" />
								</div>
								<div className="single-blog-details-wrap">
									<div className="single-blog-details text-center">
										<Link className="tag" to="/blog-details">Europe</Link>
										<p className="date">18 September 2019</p>
										<h4 className="title">10 Best Highways for Romantic Long Drive</h4>
										<Link className="btn btn-yellow" to="/blog-details"><span>{this.props.t('Read more')}<i className="la la-arrow-right" /></span></Link>
									</div>
								</div>
							</div>
						</div>
						<div className="col-sm-6">
							<div className="single-blog style-three">
								<div className="thumb">
									<img src={publicUrl + "assets/img/blog/13.png"} alt="blog" />
								</div>
								<div className="single-blog-details-wrap">
									<div className="single-blog-details text-center">
										<Link className="tag" to="/blog-details">Europe</Link>
										<p className="date">18 September 2019</p>
										<h4 className="title">Rock Climbing Limestone Cliffs At Railay Beach</h4>
										<Link className="btn btn-yellow" to="/blog-details"><span>{this.props.t('Read more')}<i className="la la-arrow-right" /></span></Link>
									</div>
								</div>
							</div>
						</div>
						<div className="col-sm-6">
							<div className="single-blog style-three">
								<div className="thumb">
									<img src={publicUrl + "assets/img/blog/14.png"} alt="blog" />
								</div>
								<div className="single-blog-details-wrap">
									<div className="single-blog-details text-center">
										<Link className="tag" to="/blog-details">Europe</Link>
										<p className="date">19 September 2019</p>
										<h4 className="title">Magic In The Sky: Chasing Iceland’s Lights</h4>
										<Link className="btn btn-yellow" to="/blog-details"><span>{this.props.t('Read more')}<i className="la la-arrow-right" /></span></Link>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			 </div> */}
					</Slider>
				</div>

			</div>

		)

	}
}

export default withTranslation()(BlogTravel);
